import { render, staticRenderFns } from "./ImportFactorialMaterialModal.vue?vue&type=template&id=366f30a1&scoped=true"
import script from "./ImportFactorialMaterialModal.vue?vue&type=script&lang=js"
export * from "./ImportFactorialMaterialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f30a1",
  null
  
)

export default component.exports